module.exports = __webpack_public_path__ + "img/gq.b3470838.png";